// Utility to check if a set of numbers is solvable for 24
// and to generate valid sets.

const TARGET = 24;
const EPSILON = 0.00001;

// Basic operations
const OPS = [
  { apply: (a, b) => a + b, symbol: '+' },
  { apply: (a, b) => a - b, symbol: '-' },
  { apply: (a, b) => b - a, symbol: '-' }, // Reverse subtraction for convenience in loop
  { apply: (a, b) => a * b, symbol: '*' },
  { apply: (a, b) => (Math.abs(b) > EPSILON ? a / b : null), symbol: '/' },
  { apply: (a, b) => (Math.abs(a) > EPSILON ? b / a : null), symbol: '/' }
];

// Recursive solver to check if 24 is possible
// Returns a solution string or null
const solve = (nums) => {
  if (nums.length === 1) {
    if (Math.abs(nums[0].val - TARGET) < EPSILON) {
      return nums[0].expr;
    }
    return null;
  }

  // Pick any two numbers
  for (let i = 0; i < nums.length; i++) {
    for (let j = 0; j < nums.length; j++) {
      if (i === j) continue;

      const remaining = nums.filter((_, idx) => idx !== i && idx !== j);
      const a = nums[i];
      const b = nums[j];

      // Try all operations
      // We manually handle commutativity to keep expressions clean
      const operations = [
          { val: a.val + b.val, expr: `(${a.expr} + ${b.expr})` },
          { val: a.val - b.val, expr: `(${a.expr} - ${b.expr})` },
          { val: b.val - a.val, expr: `(${b.expr} - ${a.expr})` },
          { val: a.val * b.val, expr: `(${a.expr} * ${b.expr})` },
      ];
      
      if (Math.abs(b.val) > EPSILON) operations.push({ val: a.val / b.val, expr: `(${a.expr} / ${b.expr})` });
      if (Math.abs(a.val) > EPSILON) operations.push({ val: b.val / a.val, expr: `(${b.expr} / ${a.expr})` });

      for (const op of operations) {
         const result = solve([...remaining, op]);
         if (result) return result;
      }
    }
  }
  return null;
};

// Generate 4 random numbers between 1-13 that have a solution
export const generateTargetNumbers = () => {
    while (true) {
        const numbers = Array.from({ length: 4 }, () => Math.floor(Math.random() * 10) + 1); // 1-10 simpler usually
        // Prepare for solver
        const numObjs = numbers.map(n => ({ val: n, expr: n.toString() }));
        const solution = solve(numObjs);
        
        if (solution) {
            return { numbers, solution };
        }
    }
};

// Check precise evaluation of user expression
export const evaluateExpression = (expr) => {
    try {
        // Limited scope eval for safety, though inputs are controlled by buttons
        // eslint-disable-next-line
        const result = Function(`"use strict"; return (${expr})`)();
        return result;
    } catch {
        return null;
    }
};
